import React, {useEffect, useState} from "react";
import {InnerWrapper, OuterWrapper} from "../customStyledComponents/CustomStyledComponents";
import Images from "../../assets/images/Images";

interface ContentContainerProps {
    handleClick: () => void,
    tabSelected: number,
    tabId: number,
    content?: any
}

const backgroundImages = [
    null,
    Images.backgroundTabs.Tab1,
    Images.backgroundTabs.Tab2,
    Images.backgroundTabs.Tab3,
    Images.backgroundTabs.Tab4,
    Images.backgroundTabs.Tab5,
    Images.backgroundTabs.Tab5,
];

const ContentWrapper: React.FC<ContentContainerProps> = ({handleClick, tabSelected, tabId, children}) => {
    const [isTabSelected, setIsTabSelected] = useState<boolean>(false);

    useEffect(() => {
        setIsTabSelected((tabId === tabSelected))
    }, [tabId, tabSelected]);

    return(
        <OuterWrapper isTabSelected={isTabSelected} onClick={handleClick} backgroundImage={backgroundImages[tabId+1]}>
            <InnerWrapper backgroundImage={backgroundImages[tabId]}>
                { children }
            </InnerWrapper>
        </OuterWrapper>
    )
};


export default ContentWrapper;
